import globalWindowSize from '@/utils/global-window-size';
import { ReactSelectInstanceRefObject } from '../custom-react-select.types';

type TCalculateMenuPositionProps = {
  selectRef: ReactSelectInstanceRefObject;
  containerRef?: React.RefObject<HTMLDivElement | null>;
  dynamicMenuPlacement?: boolean;
  dynamicMenuPlacementOffset?: number;
  menuClass: string;
};

const calculateMenuPosition = ({
  dynamicMenuPlacementOffset = 0,
  dynamicMenuPlacement,
  selectRef,
  containerRef,
  menuClass,
}: TCalculateMenuPositionProps): 'auto' | 'top' | 'bottom' => {
  if (!dynamicMenuPlacement) return 'auto';
  // if menu height is greater than the space available below the select, place it above
  const select = selectRef?.current;
  if (!select) return 'auto';
  const controlRef = select?.controlRef as HTMLElement | null;
  if (!controlRef) {
    return 'auto';
  }

  const menuEl = containerRef?.current?.querySelector(menuClass);
  if (!menuEl) {
    return 'auto';
  }
  const rect = controlRef.getBoundingClientRect();
  const availableSpaceBelow = globalWindowSize.innerHeight - rect.bottom + dynamicMenuPlacementOffset;
  const menuHeight = menuEl.getBoundingClientRect().height;
  return availableSpaceBelow < menuHeight ? 'top' : 'bottom';
};

export default calculateMenuPosition;
